<div
  class="card card-table mb-0"
  style="background-color: #edf5fb !important; margin-top: 20px"
>
  <div class="card-body">
    <app-ag-grid-table
      [subTitle]="'Booking History'"
      #agGridRef
      [rowData]="rowData"
      [parentContext]="this"
      [columnDefs]="colDefs"
      [paginationPageSize]="paginationPageSize"
      (gridReady)="onGridReady($event)"
      (reloadTable)="reload($event)"
    ></app-ag-grid-table>
  </div>
</div>
